<div class="col1">
  <img class="bg-img" src="/img/login-bg.svg">
</div>
<div class="col2">
  <div>
    <img src="/img/logo.svg" class="logo">
    <h3>Welcome to the InterSystems Global Masters</h3>
    <p>Join our gamification platform for developers and technical professionals<br>
      to stay up-to-date, learn new technologies,<br>
      and connect with InterSystems developers worldwide!</p>
    <p><strong>Please sign in via SSO using the "Login with InterSystems SSO credentials"</strong></p>
    <button class="btn-outline" (click)="login()">Login with InterSystems SSO credentials</button>
  </div>
</div>
